import { Alert, Snackbar } from "@mui/material";
import { useToasterStore, useToasterStoreActions } from "@stores:global";

export const Toaster = () => {
  const toast = useToasterStore();
  const toastActions = useToasterStoreActions();

  const handleClose = () => {
    toastActions.setToaster({
      open: false,
    });
  };

  return (
    <Snackbar
      open={toast.open}
      autoHideDuration={toast.duration}
      onClose={handleClose}
      anchorOrigin={{
        horizontal: "right",
        vertical: "bottom",
      }}
      action={toast.action}
    >
      <Alert
        onClose={handleClose}
        severity={toast.variant}
        variant="filled"
        sx={{
          width: "100%",
          borderRadius: "30px",
          ...toast.sx,
        }}
      >
        {toast.message}
      </Alert>
    </Snackbar>
  );
};
